<div class="page-main">
	<div class="container">
		<div class="row justify-content-center">
			<div class="form-container">
				<div class="logo-box">
					<img src="assets/images/logo.png">
				</div>
				<div class="login-box">

					<div style="font-size: 28px; font-weight: 700; padding: 25px 0; text-align: center; color: #29323A">
						Log In
					</div>

					<div class="google-signIn">
						<button (click)="loginViaGoogle()" type="button">
							<img style="vertical-align: text-bottom;" width="21" src="assets/images/google-sign.png" alt="SignInWithGoogle" />
							<span style="margin-left: 8px; color: #52595F; font-size: 16px; font-family: 'Outfit'; font-weight: 500">Continue with Google</span>
						</button>

						<button (click)="loginViaApple()" type="button" style="margin-top: 10px;">
							<img style="vertical-align: text-bottom;" width="21" src="assets/images/apple-sign.png" alt="SignInWithApple" />
							<span style="margin-left: 7px; color: #52595F; font-size: 16px; font-family: 'Outfit'; font-weight: 500">Continue with Apple</span>
						</button>
					</div>

					<div class="line-hr">
						<div>or</div>
					</div>

					<div class="main-box">
						@if (loginBlocked) {
						<p class="text-danger">Quran Era is currently unavailable for your school. Please contact your teacher or school.</p>
						}
						@if (loginFaild) {
						<p class="text-danger">Wrong email or password</p>
						}
						@if (verify) {
						<p class="text-danger">Please verify your email address</p>
						}

						<form (submit)="login()">

							<mat-form-field class="full-width custom-height-input" appearance="fill" floatLabel="never" subscriptSizing="fixed">
								<input matInput id="username-input" autofocus [formControl]="emailFormControl" [errorStateMatcher]="matcher" placeholder="Email or Username">
								@if (emailFormControl.hasError('email') && !emailFormControl.hasError('required')) {
								<mat-error>
									Please enter a valid email address
								</mat-error>
								}
								@if (emailFormControl.hasError('required')) {
								<mat-error>
									Email is <strong>required</strong>
								</mat-error>
								}
							</mat-form-field>

							<mat-form-field class="full-width custom-height-input" appearance="fill" floatLabel="never" subscriptSizing="fixed">
								<input matInput autocomplete="new-password" id="password-input" [type]="hide ? 'password' : 'text'" [formControl]="passwordFormControl" [errorStateMatcher]="matcher" placeholder="Password">

								<button mat-icon-button
										matSuffix
										(click)="hide = !hide"
										type="button"
										[attr.aria-label]="'Hide password'"
										[attr.aria-pressed]="hide">

									<!-- Toggles the icon visually -->
									<mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
								</button>

								@if (passwordFormControl.hasError('required')) {
								<mat-error>
									Password is <strong>required</strong>
								</mat-error>
								}
							</mat-form-field>

							<button type="submit" class="btn-3d btn-large btn-full-width" style="margin-top: 10px">Log in</button>
						</form>

						<p style="text-align: center; margin-top: 30px"><a style="color: #CC7A00; font-size: 16px !important; font-weight: 600" [routerLink]="[ '/forgot-password' ]">Forgot password?</a></p>

						<p class="m-0" style="text-align: center; font-size: 16px !important; color: #65727D ">Don't have an account yet? <a style="color: #CC7A00; font-weight: 600 " href="/registration">Sign up Now</a></p>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<div [ngClass]="{'hidden': !disableDisplay}" class="disable-display"></div>

@if (loaderStatus) {
<div class="loader-box">
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
</div>
}
